<template>
  <section v-if="isLoggedIn && items.length" class="home-followed-topics" aria-labelledby="home-followed-topics-title">
    <header class="followed-header">
      <div>
        <h2 id="home-followed-topics-title">每日关注摘要</h2>
        <span>{{ digestDate }} · {{ changedCount ? changedCount + ' 个题材今日有变化' : '今日暂无明显变化' }} · {{ unreadCount }} 条未读</span>
      </div>
      <router-link to="/wonder/topic/following">全部 <span>→</span></router-link>
    </header>

    <div class="followed-scroll" role="list">
      <article v-for="item in items" :key="item.topic_id" class="followed-topic-card" role="listitem">
        <header>
          <h3 :title="cleanName(item.name)">
            <router-link :to="topicLink(item)">{{ cleanName(item.name) }}</router-link>
          </h3>
          <button type="button" @click="unfollow(item)">取消关注</button>
        </header>
        <div class="topic-numbers">
          <span>强度 <b>{{ value(item.score) }}</b></span>
          <span>排名 <b>{{ item.rank ? '#' + item.rank : '--' }}</b></span>
          <span :class="changeClass(item.today_pct)">均涨 <b>{{ pct(item.today_pct) }}</b></span>
        </div>
        <div v-if="item.core_stocks && item.core_stocks.length" class="core-stocks" :title="'核心股盘中快照 ' + (item.core_stocks[0].core_calculated_at || '--')">
          <strong>核心</strong>
          <span v-for="stock in item.core_stocks.slice(0, 2)" :key="stock.code">{{ stock.name }} <b :class="changeClass(stock.pct)">{{ pct(stock.pct) }}</b></span>
        </div>
        <topic-daily-changes :changes="item.daily_changes || []" :digest-date="digestDate" />
        <div v-if="item.continuity && item.continuity.available" class="state-box">
          <div class="state-title">
            <strong :class="continuityStateClass(item.continuity.state)">{{ item.continuity.state }}</strong><span>持续 {{ value(item.continuity.continuity_score) }}</span>
          </div>
          <p>{{ item.continuity.state_summary }}</p>
        </div>
        <div v-else class="state-box muted">历史评分不足，暂不形成持续判断。</div>
        <footer class="card-footer-line">
          <span v-if="item.has_update" class="update-dot">有更新</span>
          <span v-else>截至 {{ item.trade_date || '--' }}</span>
          <router-link :to="topicLink(item)">查看详情 →</router-link>
        </footer>
        <div v-if="item.analysis_locked" class="unlock-line">
          完整五日轨迹、支持依据与风险条件为题材表格 VIP 权益
          <button type="button" @click="subscribe(item)">查看 ¥599 订阅</button>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
import { request_zzquant } from '@/network/request'
import TopicDailyChanges from '@/components/home/TopicDailyChanges.vue'
import { trackProductEvent } from '@/utils/productAnalytics'

export default {
  components: { TopicDailyChanges },
  name: 'HomeFollowedTopics',
  data() {
    return { items: [], digestDate: '', changedCount: 0, unreadCount: 0 }
  },
  computed: {
    isLoggedIn() {
      try { return Boolean(localStorage.getItem('token')) } catch (e) { return false }
    }
  },
  mounted() {
    if (this.isLoggedIn) this.load()
    this.$root.$on('topic-follow-status-changed', this.load)
    this.$root.$on('topic-follow-alerts-read', this.load)
  },
  beforeDestroy() {
    this.$root.$off('topic-follow-status-changed', this.load)
    this.$root.$off('topic-follow-alerts-read', this.load)
  },
  methods: {
    cleanName(name) {
      return String(name || '').replace(/\s*[（(][^（）()]*[）)]/g, '').trim()
    },
    topicLink(item) {
      return { path: '/wonder/topic/detail/' + encodeURIComponent(item.unique_key || item.topic_id), query: { source: 'home_followed' } }
    },
    value(value) {
      if (value === null || value === undefined) return '--'
      const number = Number(value)
      return Number.isFinite(number) ? number.toFixed(1) : '--'
    },
    pct(value) {
      if (value === null || value === undefined) return '--'
      const number = Number(value)
      if (!Number.isFinite(number)) return '--'
      return `${number > 0 ? '+' : ''}${number.toFixed(2)}%`
    },
    changeClass(value) {
      const number = Number(value)
      return number > 0 ? 'is-up' : number < 0 ? 'is-down' : ''
    },
    continuityStateClass(state) {
      if (state === '退潮迹象') return 'state-ebb'
      if (state === '转弱观察' || state === '高位分歧') return 'state-watch'
      if (state === '延续增强') return 'state-strong'
      if (state === '持续稳定') return 'state-stable'
      return 'state-neutral'
    },
    async load() {
      if (!this.isLoggedIn) {
        this.items = []
        return
      }
      try {
        const response = await request_zzquant({ url: '/v3/topic/follows', noRedirect: true })
        const body = response && response.data
        this.digestDate = body?.data?.digest_date || ''
        this.changedCount = body?.data?.changed_topic_count || 0
        this.unreadCount = body?.data?.unread_count || 0
        this.items = body && body.data && Array.isArray(body.data.items) ? body.data.items : []
      } catch (e) {
        this.items = []
      }
    },
    async unfollow(item) {
      await request_zzquant({ url: `/v3/topic/follows/${item.topic_id}`, method: 'DELETE' })
      this.items = this.items.filter(row => row.topic_id !== item.topic_id)
      this.$root.$emit('topic-follow-status-changed')
    },
    subscribe(item) {
      trackProductEvent('subscription_click', { topic_id: item.topic_id, source: 'home_followed', module_code: 'topic_kline' })
      this.$router.push({ path: '/subscription', query: { module: 'topic_kline', source: 'home_followed', topic_id: item.topic_id } })
    }
  }
}
</script>

<style scoped>
.home-followed-topics { --followed-bg:var(--bg-card, #fff); --followed-ink:var(--text-main, #263445); --followed-muted:var(--text-secondary, #6f7c89); --followed-border:var(--border-color, #e3e8ee); --followed-link:#47749e; --followed-up:#c84435; --followed-down:#269c50; --followed-update:#bd4938; --followed-state-stable:#2876a8; --followed-state-strong:#b83d31; --followed-state-watch:#c27618; --followed-state-ebb:#b42318; margin-top:10px; color:var(--followed-ink); }
.followed-header { min-height:32px; display:flex; align-items:center; justify-content:space-between; gap:12px; }
.followed-header > div { display:flex; align-items:baseline; gap:8px; min-width:0; }
.followed-header h2 { margin:0; font-size:16px; font-weight:700; }
.followed-header span { color:var(--followed-muted); font-size:10px; }
.followed-header > a { flex:none; font-size:11px; font-weight:600; }
.followed-scroll { display:flex; align-items:stretch; gap:12px; overflow-x:auto; padding-bottom:2px; scroll-snap-type:x mandatory; scrollbar-width:none; }
.followed-scroll::-webkit-scrollbar { display:none; }
.followed-topic-card { flex:0 0 calc((100% - 60px) / 6); min-width:0; display:flex; flex-direction:column; padding:9px 10px; background:var(--followed-bg); border:1px solid var(--followed-border); border-radius:8px; scroll-snap-align:start; }
.followed-topic-card > header { display:flex; align-items:center; justify-content:space-between; gap:6px; }
.followed-topic-card h3 { min-width:0; margin:0; font-size:13px; line-height:1.3; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.followed-topic-card h3 a { color:inherit; }
.followed-topic-card > header > button { flex:none; border:0; background:none; color:var(--followed-muted); font-size:9px; white-space:nowrap; cursor:pointer; }
.topic-numbers { display:flex; align-items:flex-start; justify-content:space-between; gap:4px; margin:9px 0 7px; color:var(--followed-muted); font-size:8px; line-height:1.2; white-space:nowrap; }
.topic-numbers b { display:block; margin-top:2px; color:var(--followed-ink); font-size:11px; font-variant-numeric:tabular-nums; }
.topic-numbers .is-up b { color:var(--followed-up); }
.topic-numbers .is-down b { color:var(--followed-down); }
.core-stocks { display:flex; align-items:center; gap:4px 7px; flex-wrap:wrap; margin-bottom:7px; color:var(--followed-muted); font-size:8px; }
.core-stocks > strong { color:var(--followed-ink); }
.core-stocks span { white-space:nowrap; }
.core-stocks b { color:var(--followed-ink); }
.core-stocks b.is-up { color:var(--followed-up); }
.core-stocks b.is-down { color:var(--followed-down); }
.state-box { flex:1; min-height:68px; margin-top:auto; padding:7px; border-radius:5px; background:var(--followed-soft, #f5f7fa); }
.state-title { display:flex; align-items:center; justify-content:space-between; gap:5px; }
.state-title strong { min-width:0; font-size:10px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.state-title strong.state-stable { color:var(--followed-state-stable); }
.state-title strong.state-strong { color:var(--followed-state-strong); }
.state-title strong.state-watch { color:var(--followed-state-watch); }
.state-title strong.state-ebb { color:var(--followed-state-ebb); }
.state-title strong.state-neutral { color:var(--followed-muted); }
.state-title span { flex:none; color:var(--followed-muted); font-size:8px; }
.state-box p { margin:4px 0 0; color:var(--followed-text, #536174); font-size:9px; line-height:1.45; overflow-wrap:anywhere; }
.state-box.muted { color:var(--followed-muted); font-size:9px; }
.card-footer-line { display:flex; align-items:center; justify-content:space-between; gap:5px; margin-top:7px; color:var(--followed-muted); font-size:8px; white-space:nowrap; }
.card-footer-line a { flex:none; color:var(--followed-link); font-weight:600; }
.update-dot { color:var(--followed-update); font-weight:700; }
.unlock-line { display:flex; align-items:center; justify-content:space-between; gap:4px 6px; flex-wrap:wrap; margin:7px -10px -9px; padding:6px 10px; background:var(--followed-unlock-bg, #fff6e1); color:var(--followed-unlocked, #75603b); font-size:8px; line-height:1.4; }
.unlock-line button { flex:none; border:0; background:none; color:var(--followed-unlock-link, #b06b00); font-size:8px; font-weight:700; white-space:nowrap; cursor:pointer; }
@media(max-width:1000px) { .followed-topic-card { flex-basis:calc((100% - 36px) / 4); } }
@media(max-width:650px) { .followed-header > div { display:block; }.followed-header span { display:block; margin-top:2px; }.followed-topic-card { flex-basis:calc(50% - 6px); }.topic-numbers { font-size:9px; }.topic-numbers b { font-size:12px; }.state-box { min-height:76px; }.state-box p,.card-footer-line,.unlock-line { font-size:9px; } }
</style>

<style>
.theme-dark .home-followed-topics { --followed-link:#8fb8e8; --followed-up:#e88978; --followed-down:#78c89a; --followed-update:#e88978; --followed-soft:#2b3442; --followed-text:#c6ceda; --followed-unlock-bg:#3b3428; --followed-unlocked:#d8bb77; --followed-unlock-link:#e7bd6d; --followed-state-stable:#75b9e6; --followed-state-strong:#f08b7d; --followed-state-watch:#e7b45f; --followed-state-ebb:#ff766c; }
</style>
